module.exports = __webpack_public_path__ + "img/william-howard-taft.366deadd.png";